/**
 * Detail view for one bulk RMA action request: outcome counts, chunk ledger, and a filtered
 * page of returns.
 */
import { observer } from 'mobx-react-lite';

import { FONT_COLOR, FONT_VARIANT } from '../../../../../../components/fonts/font-props';
import FontBody2 from '../../../../../../components/fonts/font-body2/font-body2';
import LinearLoader from '../../../../../../components/loaders/linear-loader/linear-loader';
import bulkRmaActionRequestDetailStore from '../../stores/bulk-rma-action-request-detail-store';
import ChunkLedgerTable from '../chunk-ledger-table/chunk-ledger-table';
import RequestReturnsSection from './request-returns-section';
import RequestSummarySection from './request-summary-section';

const RequestDetailPanel: React.FC = observer(() => {
    const {
        isLoading,
        error,
        detail,
    } = bulkRmaActionRequestDetailStore;

    if (isLoading && !detail) {
        return <LinearLoader />;
    }

    if (error && !detail) {
        return (
            <FontBody2 color={FONT_COLOR.SEMANTIC_DANGER} variant={FONT_VARIANT.BOLD}>
                {error}
            </FontBody2>
        );
    }

    if (!detail) {
        return null;
    }

    return (
        <div className="bulk-rma-actions-page__detail">
            <RequestSummarySection />

            <ChunkLedgerTable jobs={detail.jobs} />

            <RequestReturnsSection />
        </div>
    );
});

export default RequestDetailPanel;
